import { render } from "./dashboard-en.vue?vue&type=template&id=68a8c64c&scoped=true"
import script from "./dashboard-en.vue?vue&type=script&lang=js"
export * from "./dashboard-en.vue?vue&type=script&lang=js"

import "./dashboard-en.vue?vue&type=style&index=0&id=68a8c64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a8c64c"]])

export default __exports__